<template>
  <transition name="slide">
    <div v-if="visible" class="fixed inset-0 z-50 flex">
      <!-- Overlay -->
      <div class="fixed inset-0 bg-black bg-opacity-30" @click="emit('close')"></div>
      <!-- Drawer -->
      <div class="ml-auto w-full max-w-md bg-white h-full shadow-xl flex flex-col relative">
        <button class="absolute top-4 right-4 text-gray-400 hover:text-pink-500 text-2xl" @click="emit('close')">
          <i class="fas fa-times"></i>
        </button>
        <div class="p-6">
          <h2 class="text-xl font-bold mb-4">Roster</h2>
          <div class="mb-2 text-gray-600">Team: <span class="font-semibold">{{ team?.team_name || team?.name }}</span></div>
          <div class="mb-6 text-gray-500 text-sm">League: {{ leagueId }}</div>
          <div>
            <ul v-if="team && (team.roster || team.players)">
              <li v-for="player in (team.roster || team.players)" :key="player.id || player.name" class="py-2 border-b last:border-b-0 flex items-center space-x-2">
                <i class="fas fa-user text-gray-400"></i>
                <span>{{ player.name || player.player_name }}</span>
              </li>
            </ul>
            <div v-else class="text-gray-400 italic">No roster data available for this team.</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
const props = defineProps({
  visible: Boolean,
  team: Object,
  leagueId: String
})
const emit = defineEmits(['close'])
</script>

<style scoped>
.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s cubic-bezier(.4,0,.2,1), opacity 0.3s;
}
.slide-enter-from, .slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style> 